import { create } from "zustand";

const REPORTING_VIEW_OVERRIDE_STORAGE_KEY = "reporting-view-override";

export type ReportingViewOverride = "default" | "single" | "multi";

const VALID_OVERRIDES: readonly ReportingViewOverride[] = [
  "default",
  "single",
  "multi",
];

function isValidOverride(value: unknown): value is ReportingViewOverride {
  return VALID_OVERRIDES.includes(value as ReportingViewOverride);
}

type ReportingViewOverrideState = {
  viewOverride: ReportingViewOverride;
  setViewOverride: (value: ReportingViewOverride) => void;
};

export const useReportingViewOverride = create<ReportingViewOverrideState>(
  (set) => ({
    viewOverride: (() => {
      if (typeof window === "undefined") return "default";
      const stored = localStorage.getItem(REPORTING_VIEW_OVERRIDE_STORAGE_KEY);
      return isValidOverride(stored) ? stored : "default";
    })(),
    setViewOverride: (value: ReportingViewOverride) => {
      localStorage.setItem(REPORTING_VIEW_OVERRIDE_STORAGE_KEY, value);
      set({ viewOverride: value });
    },
  }),
);
